import React from "react";
import App from "./App";

// Tool subdomains were retired with the /tools suite (2026-09-08).
// Kept as a passthrough so index.tsx keeps its stable entry point.
const SubdomainRouter: React.FC = () => <App />;

export default SubdomainRouter;
